<script>
    import Common from "../common/index";
    // import * as commonServer from "../../../../../../api/common";

    export default {
        name: "yinpin",
        mixins: [Common],
        watch: {
            show:{
                handler(vl) {
                    if (vl) {
                        this.init()
                    }
                },
                deep: true,
                immediate: true
            }
        },
        data(){
            return {
                type: 'audio',
                config: [
                    {
                        type: 'SearchBox',
                        value: '',
                        fixed: true
                    },
                    {
                        type: 'UploadBtn',
                        value: '',
                        fixed: true
                    },
                    // {
                    //     type: 'LuyinBtn',
                    //     value: '',
                    //     fixed: true
                    // },
                    // {
                    //     type: 'LuyinWxBtn',
                    //     value: '',
                    //     fixed: true
                    // },
                    // {
                    //     type: 'LuyinAiBtn',
                    //     value: '',
                    //     fixed: true
                    // },
                    {
                        type: 'TypeBtn',
                        value: '',
                        selected: '2',
                        fixed: true
                    },
                    {
                        type: 'CatalogType',
                        value: '',
                        selected: '',
                        fixed: true
                    },
                    {
                        type: 'SelectList',
                        form: [
                            // {
                            //     title: '分类一',
                            //     data: [
                            //         {id:0, name: '模仿翻唱-阿丽塔', time: '01:58', play: false, love: false, status: false},
                            //         {id:1, name: '模仿翻唱-阿丽塔', time: '01:58', play: false, love: false, status: false},
                            //         {id:2, name: '模仿翻唱-阿丽塔', time: '01:58', play: false, love: false, status: false},
                            //         {id:3, name: '模仿翻唱-阿丽塔', time: '01:58', play: false, love: false, status: false},
                            //     ]
                            // }
                        ],
                        selected: [],
                        isShop: false
                    },
                    {
                        type: 'SearchList',
                        value: ''
                    },
                    {
                        type: 'MoreBtn',
                        value: ''
                    },
                ]
            }
        },
        methods:{
            // init(){
            //     this.flashData()
            // },
            // async flashData(){
            //     let index = this.getIndexByType('SelectList')
            //     // 获取所有的音频一级目录
            //     const res = await commonServer.default[this.getResourceCategoryTree]({
            //         clientsId: this.$store.state.initConfig.school_id,
            //         sort: 'audio'
            //     })
            //     console.log('获取音频列表分类==>', res.data)
            //     this.config[index].selected = []
            //     this.config[index].form = res.data.filter(v=>v.parent_id === 0).map(q=>{
            //         return {
            //             title: q.name,
            //             column: 1,
            //             data: [],
            //             ...q,
            //         }
            //     })
            //
            //     let obj = {}
            //     this.config[index].form.map(async (v,i)=>{
            //         obj = {
            //             clientsId: this.$store.state.initConfig.school_id,
            //             sort: 'audio',
            //             categoryId: v.id
            //         }
            //         if(this.search){
            //             obj.search = this.search
            //         }
            //
            //         // 数据请求地址 & 参数
            //         v.apiConfig = {
            //             params: obj,
            //             request: commonServer.default[this.getResourceList]
            //         }
            //
            //         if(i===0){
            //             let data = await commonServer.default[this.getResourceList](obj)
            //             v.data = data.items.map(q=>{
            //                 return {
            //                     url: q.attributes.resources.url,
            //                     ...q
            //                 }
            //             })
            //
            //             // 如果第一个数据有值默认选中第一个展开
            //             if(v.data && v.data.length>0) {
            //                 this.config[index].selected = [i]
            //             }
            //         }
            //     })
            // },
            onSearchBox(search){
                this.search = search
                // this.flashData()
            }
        }
    }
</script>
